// extracted by mini-css-extract-plugin
export default {"label":"Checkbox-module__label__Jn-iD","fakeBox":"Checkbox-module__fakeBox__RX4C3","inverted":"Checkbox-module__inverted__obS8s","input":"Checkbox-module__input__vzLcO"};